export default "__VITE_ASSET__jhNRuGnO__"